var unitlessNumbers={
animationIterationCount:true,
borderImageOutset:true,
borderImageSlice:true,
borderImageWidth:true,
boxFlex:true,
boxFlexGroup:true,
boxOrdinalGroup:true,
columnCount:true,
flex:true,
flexGrow:true,
flexOrder:true,
flexPositive:true,
flexShrink:true,
flexNegative:true,
fontWeight:true,
gridRow:true,
gridColumn:true,
lineClamp:true,
opacity:true,
order:true,
orphans:true,
tabSize:true,
widows:true,
zIndex:true,
zoom:true,

fillOpacity:true,
floodOpacity:true,
stopOpacity:true,
strokeDasharray:true,
strokeDashoffset:true,
strokeMiterlimit:true,
strokeOpacity:true,
strokeWidth:true,

scale:true,
scaleX:true,
scaleY:true,
scaleZ:true,

shadowOpacity:true};


module.exports=unitlessNumbers;


// WEBPACK FOOTER //
// ./~/react-native-web/dist/modules/unitlessNumbers/index.js